import { CommonAction } from "@/actions/common/common";
import { CustomToastrAction } from "@/actions/components/custom-toastr";
import { REDIRECT } from "@/constants/common/urls";
import { CandidateInfoEditService } from "@/services/components/candidate-info-edit-form";
import { CandidateGeneralProfileService } from "@/services/pages/clients/candidates/view_profile";
import { CandidateProfileJobService } from "@/services/pages/clients/jobs/candidate-profile-job";
import { saveAs } from 'file-saver';



export class ViewProfileActions {
    constructor(router) {
        this.candidateInfoEdit = new CandidateInfoEditService();
        this.commonAction = new CommonAction();
        this.customToastrAction = new CustomToastrAction();
        this.router = router
    }

    async like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
        var candidate_id = router.query.candidate_id;
        var body = { liked: value }
        var result = await new CandidateGeneralProfileService().like_dislike(body, candidate_id);
        setLikeDislike(value);

        if (result.request.status == 200) {
            initialData.application.liked_unliked = value;
            initialData.notes = result.data.notes;
            setInitialData(initialData)
            setFlagForRerender(Math.random() * 10000);
        }
        else {
            setApiError(result.request)
        }

    }


    goToOtherCandidate(router, candidate_id) {
        if (candidate_id) {
            var path = REDIRECT.client.jobs.candidate_profile_view.replace('$candidate_id', candidate_id);
            router.push({ pathname: path, query: router.query })
        }
    }

    candidateDownloadCV(url) {
        if (url) {
            saveAs(url, 'Resume.pdf');
        }
        else {
            this.customToastrAction.setNormalToastr('CV does not exists', 'error');
            // toastr.error('CV does not exists');
        }
    }

    candidateOpenEmail(setShowCandidateEmail, candidate_email, setReplyTo, setReplySubject, initialData, setOpenFrom, type, setReferences) {
        if (candidate_email) {
            setReplyTo('');
            if(setReferences) setReferences('')
            setReplySubject('');
            setOpenFrom(type);
            setShowCandidateEmail(true);
        }
        else {
            this.customToastrAction.setNormalToastr('Email does not exists', 'error');
            // toastr.error('Email does not exists');
        }
    }

    async downloadEsignFile(contract_id, contract_title) {
        var result = await new CandidateProfileJobService().downloadContract(
          contract_id
        );
        saveAs(result.data, `${contract_title}.${result.data.type.split("/")[1]}`);
    }

    candidateShareCV(setButtonPopup, cv_url) {
        if (cv_url) {
            setButtonPopup(true);
        }
        else {
            this.customToastrAction.setNormalToastr('CV does not exists', 'error');
            // toastr.error('CV does not exists');
        }
    }

    async submitCandidateNote(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
        const message = document.querySelector('.autocompleteInput textarea').value;
        let body = { message: message, member_tag_ids: mentionsMember, private: values.private };
        let result = await new CandidateGeneralProfileService().addNote(body, router.query.candidate_id);
        initialData.notes = result.data.notes
        setInitialData(initialData);
        delete (router.query['section']);
        setFlagForRerender(Math.random() * 10000);
        result.request.status != 200 ? setApiError(result.request) : null;
        formik.current.resetForm();
    }


    getShareComponentMemberListArray(hash) {
        var names_hash = [];

        if (hash) {
            for (var element of hash) {
                names_hash.push({
                    id: element.user_attributes.id,
                    display: `@${element.user_attributes.name || element.user_attributes.email}`
                })
            }
        }
        return names_hash;
    }


    async getCandidateGeneralProfile(router, setApiError) {
        let result = await new CandidateProfileJobService().getCandidateGeneralViewData(router.query);
        if(setApiError) setApiError(result.request)
        return result.data;
    }


    async addCv(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
        setShowLoader(true);
        const formData = new FormData();
        var result = ''

        if (this.commonAction.check_file_size(event.target.files[0], 10485760)) {
            if (type == 'candidate_profile') {
                formData.append(`job_application[candidate_cv]`, event.target.files[0]);
                result = await this.candidateInfoEdit.UpdateCanidateInfo(formData, router)
                initialData.application.cv = result.data.application.cv;
            }
            else {
                formData.append(`client_candidate[cvs_attributes][default]`, true);
                formData.append(`client_candidate[cvs_attributes][0][file_type]`, 'cv');
                formData.append(`client_candidate[cvs_attributes][0][file]`, event.target.files[0]);
                result = await this.candidateInfoEdit.UpdateGeneralCandidate(formData, router);
                initialData.application.cv = result.data.application.cv;
            }
            setFlagForRerender(Math.random() * 10000);
            window.location.reload();
        }
        else {
            this.customToastrAction.setNormalToastr('The file size is greater than 10MB', 'warning');
        }

        setShowLoader(false);
    }

    async updateCv(event, router, initialData, setFlagForRerender, type, setShowLoader) {
        setShowLoader(true);
        const formData = new FormData();
        var result = ''

        if (this.commonAction.check_file_size(event.target.files[0], 10485760)) {
            if (type == 'candidate_profile') {
                formData.append(`job_application[update_cv]`, true);
                formData.append(`job_application[candidate_cv]`, event.target.files[0]);
                result = await this.candidateInfoEdit.UpdateCanidateInfo(formData, router)
                initialData.application.cv = result.data.application.cv;
            }
            else {
                formData.append(`client_candidate[cvs_attributes][default]`, true);
                formData.append(`client_candidate[update_cv]`, true);
                formData.append(`client_candidate[cvs_attributes][0][file_type]`, 'cv');
                formData.append(`client_candidate[cvs_attributes][0][file]`, event.target.files[0]);
                result = await this.candidateInfoEdit.UpdateGeneralCandidate(formData, router);
                initialData.application.cv = result.data.application.cv;
            }

            setFlagForRerender(Math.random() * 10000);
            window.location.reload();
        }
        else {
            this.customToastrAction.setNormalToastr('The file size is greater than 10MB', 'warning');
        }
        setShowLoader(false);

    }

    selectTabCandidateProfileView(
        technical_tests,
        video_q_a,
        candidate_answers,
        tab_name
      ) {
        const tabs = [];
        if (candidate_answers) tabs.push("screening");
        tabs.push("notes", "comms", "scorecards");
        if (technical_tests) tabs.push("technical_tests");
        if (video_q_a.length > 0) tabs.push("video_q_a");
        tabs.push("application", "info_and_docs", "timeline", "offer");
        const tabIndex = tabs.indexOf(String(tab_name));
        return tabIndex === -1 ? 0 : tabIndex;
      }

    selectTabGeneralViewProfile(tab_name) {
        switch (tab_name) {
            case 'notes': return 0;
            case 'comms': return 1;
            case 'info_and_docs': return 2;
            case 'previous_application': return 3;
            default: return 0;
        }
    }

    selectTabCandidateProfileViewOnClick(index, video_q_a, technical_tests, screening_answers) {
        let tab_name = this.getTabFromIndexCandidateProfileView(index, video_q_a, technical_tests, screening_answers)
        this.router.query.tab = tab_name;
        this.commonAction.asyncAddParamsToUrl(this.router.query, this.router);
    }

    getTabFromIndexCandidateProfileView(index, initialData) {
        const tabs = [
            initialData.candidate_answers && 'screening_answers', 
            'notes',
            'comms',
            'scorecards',
            initialData.technical_tests && 'assessment',
            initialData.video_q_a?.length > 0 && 'video_qa',
            'application',
            'info&docs',
            'timeline',
            'offer',
        ].filter(Boolean);
        
        return tabs[index] || 'notes'; 
    }

    selectTabGeneralProfileViewOnClick(index) {
        let tab_name = this.getTabFromIndexGeneralProfileView(index)
        this.router.query.tab = tab_name;
        this.commonAction.asyncAddParamsToUrl(this.router.query, this.router);
    }

    getTabFromIndexGeneralProfileView(index) {
        switch (index) {
            case 0: return 'notes';
            case 1: return 'comms';
            case 2: return 'info_and_docs';
            case 3: return 'previous_application';
            case 4: return 'timeline';
            default: return 'notes';
        }
    }


}




// TODO :- REMOVE THESE CODE AFTER REMOVING IT FROM THE OTHER FILES IN WHICH THEY ARE USED
export async function like_dislike(value, router, setLikeDislike, setApiError, initialData, setInitialData, setFlagForRerender) {
    var candidate_id = router.query.candidate_id;
    var body = { liked: value }
    var result = await new CandidateGeneralProfileService().like_dislike(body, candidate_id);
    setLikeDislike(value);

    if (result.request.status == 200) {
        initialData.application.liked_unliked = value;
        initialData.notes = result.data.notes;
        setInitialData(initialData)
        setFlagForRerender(Math.random() * 10000);
    }
    else {
        setApiError(result.request)
    }

}

export function goToOtherCandidate(router, candidate_id) {
    if (candidate_id) {
        var path = REDIRECT.client.jobs.candidate_profile_view.replace('$candidate_id', candidate_id);
        router.push({ pathname: path, query: router.query })
    }
}

export function candidateDownloadCV(url) {
    const customToastrAction = new CustomToastrAction();

    if (url) {
        saveAs(url, 'Resume.pdf');
    }
    else {
        customToastrAction.setNormalToastr('CV does not exists', 'error');
        // toastr.error('CV does not exists');
    }
}
export function candidateOpenEmail(setShowCandidateEmail, candidate_email, setReplyTo, setReplySubject,setOpenFrom, type, setReferences) {
    const customToastrAction = new CustomToastrAction();

    if (candidate_email) {
        setReplyTo('');
        if(setReferences) setReferences('')
        setReplySubject('');
        setOpenFrom(type)
        setShowCandidateEmail(true);
    }
    else {
        customToastrAction.setNormalToastr('Email does not exists', 'error');
        // toastr.error('Email does not exists');
    }
}

export function candidateShareCV(setButtonPopup, cv_url) {
    const customToastrAction = new CustomToastrAction();

    if (cv_url) {
        setButtonPopup(true);
    }
    else {
        customToastrAction.setNormalToastr('CV does not exists', 'error');
        // toastr.error('CV does not exists');
    }
}

export async function submitCandidateNote(values, router, setMentionsInputValue, mentionsMember, initialData, setInitialData, setApiError, setFlagForRerender, formik) {
    const message = document.querySelector('.autocompleteInput textarea').value;
    let body = { message: message, member_tag_ids: mentionsMember, private: values.private };
    let result = await new CandidateGeneralProfileService().addNote(body, router.query.candidate_id);
    initialData.notes = result.data.notes
    setInitialData(initialData);
    delete (router.query['section']);
    setFlagForRerender(Math.random() * 10000);
    result.request.status != 200 ? setApiError(result.request) : null;
    formik.current.resetForm();
}

export function getShareComponentMemberListArray(hash) {
    var names_hash = [];

    if (hash) {
        for (var element of hash) {
            names_hash.push({
                id: element.user_attributes.id,
                display: `@${element.user_attributes.name || element.user_attributes.email}`
            })
        }
    }
    return names_hash;
}


export async function getCandidateGeneralProfile(router, setApiError) {
    let result = await new CandidateProfileJobService().getCandidateGeneralViewData(router.query);
    if(setApiError) setApiError(result.request)
    return result.data;
}


export async function addCv(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
    setShowLoader(true);
    const formData = new FormData();
    var result = ''

    if (type == 'candidate_profile') {
        formData.append(`job_application[candidate_cv]`, event.target.files[0]);
        result = await new CandidateInfoEditService().UpdateCanidateInfo(formData, router)
        initialData.application.cv = result.data.application.cv;
    }
    else {
        formData.append(`client_candidate[cvs_attributes][default]`, true);
        formData.append(`client_candidate[cvs_attributes][0][file_type]`, 'cv');
        formData.append(`client_candidate[cvs_attributes][0][file]`, event.target.files[0]);
        result = await new CandidateInfoEditService().UpdateGeneralCandidate(formData, router);
        initialData.application.cv = result.data.application.cv;
    }
    setFlagForRerender(Math.random() * 10000);
    setShowLoader(false);
    window.location.reload();
}

export async function updateCv(event, setLoading, router, setInitialData, initialData, setFlagForRerender, type, setShowLoader) {
    setShowLoader(true);
    const formData = new FormData();
    var result = ''
    if (type == 'candidate_profile') {
        formData.append(`job_application[candidate_cv]`, event.target.files[0]);
        result = await new CandidateInfoEditService().UpdateCanidateInfo(formData, router)
        initialData.application.cv = result.data.application.cv;
    }
    else {
        formData.append(`client_candidate[cvs_attributes][default]`, true);
        formData.append(`client_candidate[cvs_attributes][0][file_type]`, 'cv');
        formData.append(`client_candidate[cvs_attributes][0][file]`, event.target.files[0]);
        result = await new CandidateInfoEditService().UpdateGeneralCandidate(formData, router);
        initialData.application.cv = result.data.application.cv;
    }
    setFlagForRerender(Math.random() * 10000);
    setShowLoader(false);
    window.location.reload();
}

// TODO :- REMOVE THESE CODE AFTER REMOVING IT FROM THE OTHER FILES IN WHICH THEY ARE USED
